import { useSearchParams, useParams } from 'react-router-dom'
import LocksmithFinder from './LocksmithFinder'
import ErrorBoundaryWrapper from './ErrorBoundaryWrapper'
import { getTradeBySlug } from '../config/trades'

export default function FindPage() {
  const [searchParams] = useSearchParams();
  const { trade: tradeSlug } = useParams<{ trade: string }>();

  // Validate trade slug, default to 'locksmith'
  const trade = (tradeSlug && getTradeBySlug(tradeSlug)) ? tradeSlug : 'locksmith';

  // Directly derive values from URL params instead of using state
  const postcode = searchParams.get('postcode') || '';
  const serviceType = searchParams.get('serviceType') || 'home';
  const autoSearch = searchParams.get('autoSearch') === 'true';

  // Create a unique key based on the search parameters to force component remount
  // This ensures that when URL params change, LocksmithFinder gets a fresh instance
  const searchKey = `${trade}-${postcode}-${serviceType}-${autoSearch}-${Date.now()}`;

  return (
    <ErrorBoundaryWrapper>
      <main className="w-full h-screen">
        <LocksmithFinder
          key={searchKey}
          initialPostcode={postcode}
          initialServiceType={serviceType}
          trade={trade}
        />
      </main>
    </ErrorBoundaryWrapper>
  );
}
